function getFileTypeLabel(fileType) {
  if (fileType === '') return;
  const fileExtension = fileType.split('/')[1];
  const capitalizedExtension = fileExtension.toUpperCase();
  return capitalizedExtension;
}

export default getFileTypeLabel;
